import { render, staticRenderFns } from "./OrmMessageViewSideMenu.vue?vue&type=template&id=cfa51740"
import script from "./OrmMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfa51740')) {
      api.createRecord('cfa51740', component.options)
    } else {
      api.reload('cfa51740', component.options)
    }
    module.hot.accept("./OrmMessageViewSideMenu.vue?vue&type=template&id=cfa51740", function () {
      api.rerender('cfa51740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageViewSideMenu.vue"
export default component.exports